import { ModelHealth } from "@/components/ModelHealth";
import { useModuleVideos } from "@/lib/useModuleVideos";
import { OneClickReview } from "@/components/admin/OneClickReview";
import { ModuleVideoManager } from "@/components/admin/ModuleVideoManager";
import { BookPreviews, ContentLinks } from "@/components/admin/ContentExtras";

export const AdminContentTab = () => {
  const { available, uploadingId, upload, remove } = useModuleVideos();
  return (
    <div className="space-y-10" data-testid="admin-content-preview">
      <ModelHealth />
      <OneClickReview available={available} />
      <BookPreviews />
      <ModuleVideoManager available={available} uploadingId={uploadingId} onUpload={upload} onRemove={remove} />
      <ContentLinks />
    </div>
  );
};
